import React, { useState } from 'react';

// import whiteArrowDown from './assets/white-arrow-down.svg';
import styles from './SearchInputDropdown.module.css';

const SearchInputDropdown = () => {
  // const {  } = props;
  const [showDropdown] = useState(false);

  return (
    <div
      className={styles.searchInputDropdownPlaceholder}
      // onClick={() => setShowDropdown(!showDropdown)}
      role="presentation"
    >
      SURVEY NAME CONTAINING
      {showDropdown ? (
        <div className={styles.searchInputDropdown}>
          <div className={styles.dropdownItem}>CREATOR NAME CONTAINING</div>
        </div>
      ) : null}
    </div>
  );
};

export default SearchInputDropdown;
